import ace, { IAceEditorProps } from "./ace";
import diff, { IDiffEditorProps, IDiffEditorState } from "./diff";
import split, { ISplitEditorProps } from "./split";
import {
  IAceOptions,
  ICommand,
  ICommandBindKey,
  ICommandManager,
  IEditorProps,
  IMarker
} from "./types";
export {
  split,
  diff,
  IAceOptions,
  IAceEditorProps,
  ICommand,
  ICommandBindKey,
  ICommandManager,
  IDiffEditorProps,
  IDiffEditorState,
  IEditorProps,
  IMarker,
  ISplitEditorProps
};
export default ace;
